const SITE_SETTINGS_CACHE_KEY = 'karga_site_settings_cache_v1';

export function getCachedSiteSettings() {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(SITE_SETTINGS_CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

export function setCachedSiteSettings(settings) {
  if (typeof window === 'undefined' || !settings || typeof settings !== 'object') return;

  try {
    window.localStorage.setItem(SITE_SETTINGS_CACHE_KEY, JSON.stringify(settings));
  } catch (error) {
    // Ignore cache write errors so page rendering is never blocked.
  }
}
